import { useTranslation } from 'react-i18next';
import deleteIcon from '@/assets/delete_black.svg';

const SearchHistoryBox = ({ searchHistory, onClearHistory, onSelectHistory, className }) => {
  const { t } = useTranslation();

  if (!searchHistory || searchHistory.length === 0) {
    return null;
  }

  return (
    <div className={`px-4 pt-3 pb-6 bg-white rounded-md shadow-[0px_4px_12px_0px_rgba(0,0,0,0.10)] outline outline-1 outline-offset-[-1px] outline-[#dddddd] flex flex-col justify-start items-start gap-4 ${className}`}>
      <div className="inline-flex justify-between items-center w-full">
        <div className="text-[#aaaaaa] text-sm">{t('common.search_history')}</div>
        <div 
          className="w-8 h-8 rounded-[18px] flex justify-center items-center gap-2.5 cursor-pointer hover:bg-[#f4f4f4]"
          onClick={onClearHistory}
        >
          <img src={deleteIcon} alt="close" className="w-4 h-4" />
        </div>
      </div>
      <div className="inline-flex justify-start items-start gap-3 flex-wrap content-start">
        {searchHistory.map((term, index) => (
          <div 
            key={index} 
            className="h-9 px-3 py-2.5 rounded-[36px] outline outline-1 outline-offset-[-1px] outline-[#dddddd] flex justify-center items-center gap-3 cursor-pointer hover:bg-[#f4f4f4]"
            onClick={() => onSelectHistory(term)}
          >
            <div className="text-center text-[#111111] text-sm leading-[14px]">{term}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchHistoryBox; 